import { BookingStatus } from '@massilia/prisma-generated/enums';
import { z } from 'zod';
import { isoDateString } from '../_shared/dates.js';
export const updateBookingConditionsSchema = z.object({
    depositDeadline: isoDateString().optional(),
    exchangeAllowed: z.boolean().optional(),
    exchangeFeeDescription: z.string().optional(),
    installmentChosen: z.boolean().optional(),
    installmentMinimumDepositAmount: z.coerce.number().nullish(),
    installmentPaymentDeadline: isoDateString().optional(),
    refundAllowed: z.boolean().optional(),
    refundFeeDescription: z.string().optional(),
});
export const updateBookingStatusSchema = z.object({
    status: z.nativeEnum(BookingStatus),
});
export const updateBookingInsurancePriceSchema = z.object({
    price: z.number().min(0),
});
export const createBookingExtraSchema = z.object({
    bookingId: z.string().min(1),
    fileId: z.string().optional(),
    fileName: z.string().optional(),
    name: z.string().min(1),
    providerName: z.string().min(1),
    description: z.string().optional(),
    fileType: z.string().optional(),
    price: z.number().min(0),
    providerExternalRef: z.string().min(1),
});
export const updateBookingExtraSchema = z.object({
    fileId: z.string().optional(),
    fileName: z.string().optional(),
    name: z.string().optional(),
    providerName: z.string().optional(),
    description: z.string().nullish(),
    fileType: z.string().optional(),
    price: z.number().min(0).optional(),
    providerExternalRef: z.string().optional(),
});
